const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

function getToken() {
    const raw = localStorage.getItem("token") || "";
    return raw.startsWith("Bearer ") ? raw.slice(7) : raw;
}

export const sendChatMessageApi = async (leadId, role, message, payload = null) => {
    const token = getToken();

    try {
        const response = await fetch(
            `${API_BASE_URL}/${role}/lead/leads/${leadId}/chat/messages`,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    message,
                    payload: payload || undefined,
                }),
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            throw { ...errorData, statusCode: response.status };
        }

        const result = await response.json();

        // ✅ support all common response shapes:
        // { message: {...} } OR { data: {...} } OR {...}
        return result?.message || result?.data || result;
    } catch (error) {
        console.error("[sendChatMessageApi] Error:", error);
        throw error;
    }
};
